import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { QueryState } from '@interfaces/queries';

@Component({
	selector: 'workflow-query-state',
	templateUrl: './query-state.component.html',
	styleUrls: ['./query-state.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class QueryStateComponent {
	@Input()
	public state: QueryState = 'opened';
	
	public get icon():string{
		switch (this.state){
			case 'opened':
				return 'alert';
			case 'responded':
				return 'comment';
			case 'closed':
				return 'comment';
		}
	}
	
	@HostBinding('class.opened')
	public get isOpened():boolean{
		return this.state === 'opened';
	}
	
	@HostBinding('class.responded')
	public get isResponded():boolean{
		return this.state === 'responded';
	}
	
	@HostBinding('class.closed')
	public get isClosed():boolean{
		return this.state === 'closed';
	}
}
